/**
 * Siccas Facets Sort Fix
 *
 * Problem: Desktop sorting dropdown resets active filters
 * Solution: Intercept sort change, preserve URL parameters, use AJAX
 *
 */

(function() {
  'use strict';

  /**
   * Initialize the sort fix for desktop sorting
   */
  function initSortFix() {
    const form = document.querySelector('#FacetSortDrawerForm');
    if (!form) return;

    const customElement = form.closest('facet-filters-form');
    if (!customElement) return;

    // Remove existing listener if present (for re-initialization after AJAX)
    if (form._sortFixListener) {
      form.removeEventListener('input', form._sortFixListener, true);
    }

    // Create and store the listener
    const sortFixListener = function(e) {
      if (e.target.id === 'SortBy') {
        // Stop standard form submission that loses filters
        e.stopImmediatePropagation();
        e.preventDefault();

        // Get current URL parameters and update only sort_by
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set('sort_by', e.target.value);

        // Use existing AJAX method to update page without reload
        customElement.onSubmitForm(currentParams.toString(), e);
      }
    };

    // Attach listener in capture phase (fires before standard handlers)
    form.addEventListener('input', sortFixListener, true);

    // Store reference for cleanup
    form._sortFixListener = sortFixListener;
  }

  /**
   * Monitor for AJAX updates that replace the sorting element
   * Re-initialize the fix after updates
   */
  function monitorAjaxUpdates() {
    const sortingContainer = document.querySelector('.sorting');
    if (!sortingContainer) return;

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Sorting element was replaced by AJAX, re-initialize
          setTimeout(initSortFix, 100);
        }
      });
    });

    observer.observe(sortingContainer, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Initialize on DOM ready
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initSortFix();
        monitorAjaxUpdates();
      });
    } else {
      initSortFix();
      monitorAjaxUpdates();
    }
  }

  init();
})();
